import React, { useState } from 'react';
import { PhonemeList, segmentPhonemes } from '../../phonemes/segmentPhonemes';
import { EditSpeakOptions } from '../EditSpeakOptions';
import { speakPhonemes2 } from '../speakPhonemes2';
import { ChoiceList } from '../widgets/ChoiceList';
import { FeaturesForIpa } from './FeaturesForIpa';
import { FixupRules } from './fixupRules';
import { ReplaceSymbols } from './ReplaceSymbols';
import { PhonemeLengths } from './PhonemeLengths';
import { IpaType } from '../../phonemes/ipa';

/** allows you to examine IPA & its features */
export function ExamineArea() {
  const [segments, setSegments] = useState<PhonemeList>({ type: 'ipa', phonemes: [], hasUnknown: false });
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [approxIpa, setApproxIpa] = useState('');
  const [stress, setStress] = useState('');
  const [fixupRules] = useState(() => new FixupRules());
  const [phonemeLengths, setPhonemeLengths] = useState<Record<IpaType, number>>({});
  const [rulesStr, setRulesStr] = useState('');

  function runRules(s: string) {
    const newOutput = fixupRules.runRules(s);
    setOutput(newOutput);

    const normalized = newOutput.replaceAll(/\s/g, ' ');
    const segments = segmentPhonemes(normalized, 'ipa', 'all-aff');
    setSegments(segments);
  }

  function changeInput(s: string) {
    setInput(s);
    runRules(s);
  }

  function speak() {
    const addPhonemeLength = fixupRules.getPhonemeLengthRules();
    const { approxIpa } = speakPhonemes2(output, addPhonemeLength);
    setApproxIpa(approxIpa);
  }

  function changeStress(s: string) {
    setStress(s);
    const n = s === '' ? 0 : Number.parseInt(s);
    fixupRules.addStress(n);
    setRulesStr(fixupRules.getRulesAsString());
    runRules(input);
  }

  function addChange(from: string, to: string) {
    fixupRules.addChange(from, to);
    setRulesStr(fixupRules.getRulesAsString());
    runRules(input);
  }

  function setLength(phoneme: IpaType, length: number) {
    fixupRules.setPhonemeLength(phoneme, length);
    setPhonemeLengths(fixupRules.getLengthMap());
    setRulesStr(fixupRules.getRulesAsString());
    runRules(input);
  }
  function clearLengths() {
    fixupRules.clearPhonemeLengths();
    setPhonemeLengths(fixupRules.getLengthMap());
    setRulesStr(fixupRules.getRulesAsString());
    runRules(input);
  }

  function clearRules() {
    fixupRules.clear();
    setPhonemeLengths({});
    setRulesStr('');
    setStress('');
    runRules(input);
  }

  return (<>
    <textarea cols={50} rows={4} spellCheck={false} value={input} onChange={(event) => changeInput(event.target.value)} />
    &nbsp;
    <textarea cols={50} rows={4} spellCheck={false} value={output} readOnly={true} />
    <br />
    stress syllable:&nbsp;
    <ChoiceList items={['', '1', '2', '-2', '-1']} selectedItem={stress} onSelect={changeStress} />
    &nbsp;&nbsp;&nbsp;&nbsp;
    <button onClick={() => speak()}>speak</button>
    <br />
    <span>{'pronounced as: /' + approxIpa + '/'}</span>
    <br /><br />

    <div style={{ display: 'grid', justifyContent: 'left' }}>
      <div className='cell11'><FeaturesForIpa segments={segments} /></div>
      <div className='cell12'>&nbsp;&nbsp;&nbsp;&nbsp;</div>
      <div className='cell13'>
        <ReplaceSymbols replacements={['unknown', 'thongs', 'combine']} segments={segments} replace={addChange} />
        {rulesStr.length === 0 ? <></> : <div className='left'>
          <div className='smallTitle'>Rules for symbols & prosody</div>
          <textarea cols={30} rows={10} spellCheck={false} value={rulesStr} readOnly={true} />
          <br />
          <button onClick={() => clearRules()}>clear rules</button>
        </div>}
        <PhonemeLengths lengthMap={phonemeLengths} setLength={setLength} clearLengths={clearLengths} />
      </div>
    </div>

    <hr />
    <EditSpeakOptions />
    <br /><br />
  </>
  );
}
